export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': '앱',
            'horizontal': '수평',
            'horizontalMenu': '가로 메뉴',
            'general': '일반',
            'component': '구성 요소',
            'features': '풍모',
            'applications': '응용 분야',
            'dashboard': '계기반',
            'dashboard1': '대시 보드 1',
            'dashboard2': '대시 보드 2',
            'dashboard3': '대시 보드 3',
            'modules': '모듈',
            'agency': '대리점',
            'pages': '페이지',
            'gallery': '갱도',
            'pricing': '가격',
            'terms&Conditions': '이용 약관',
            'feedback': '피드백',
            'report': '보고서',
            'faq(s)': '주장 (들)',
            'advancedComponent': '고급 구성 요소',
            'blank': '공백',
            'session': '세션',
            'login': '로그인',
            'register': '레지스터',
            'lockScreen': '잠금 화면',
            'forgotPassword': '비밀번호를 잊으 셨나요',
            'uiComponents': 'UI 구성 요소',
            'alerts': '알리미',
            'appBar': '앱 바',
            'avatars': '아바타',
            'buttons': '버튼',
            'bottomNavigations': '하단 네비게이션',
            'badges': '배지',
            'cards': '카드',
            'cardsMasonry': '카드 석공 직',
            'chip': '칩',
            'dialog': '대화',
            'dividers': '분할기',
            'drawers': '서랍',
            'popover': 'изменение',
            'expansionPanel': '확장 패널',
            'gridList': '그리드리스트',
            'list': '명부',
            'menu': '메뉴',
            'popoverAndToolTip': '팝 오버 및 툴팁',
            'progress': '진행',
            'snackbar': '스낵바',
            'selectionControls': '선택 컨트롤',
            'advanceUiComponents': '고급 UI 구성 요소',
            'dateAndTimePicker': '날짜 및 시간 선택기',
            'tabs': '탭',
            'stepper': '스테퍼',
            'notification': '공고',
            'sweetAlert': '달콤한 알리미',
            'autoComplete': '자동 완성',
            'aboutUs': '회사 소개',
            'widgets': '위젯',
            'forms': '양식',
            'formElements': '양식 요소',
            'textField': '텍스트 필드',
            'selectList': '목록 선택',
            'charts': '차트',
            'reCharts': '레 차트',
            'reactChartjs2': '차트 2 반응',
            'icons': '아이콘',
            'themifyIcons': '테마 아이콘',
            'simpleLineIcons': '단순한 선 아이콘',
            'materialIcons': '재료 아이콘',
            'fontAwesome': '글꼴 굉장',
            'tables': '테이블',
            'basic': '기본',
            'dataTable': '데이터 표',
            'responsive': '반응 형',
            'reactTable': '반응 테이블',
            'maps': '지도',
            'googleMaps': '구글지도',
            'leafletMaps': '전단지지도',
            'inbox': '받은 편지함',
            'users': '사용자',
            'userProfile1': '사용자 프로필 1',
            'userProfile2': '사용자 프로필 2',
            'userManagement': '사용자 관리',
            'userProfile': '유저 프로필',
            'userList': '사용자 목록',
            'calendar': '달력',
            'cultures': '문화',
            'dnd': 'Dnd',
            'selectable': '선택 가능',
            'customRendering': '사용자 정의 렌더링',
            'chat': '잡담',
            'toDo': '할 것',
            'editor': '편집자',
            'wysiwygEditor': 'WYSIWYG 편집기',
            'quillEditor': '퀼 에디터',
            'reactAce': '반응하는 에이스',
            'dragAndDrop': '끌어서 놓기',
            'reactDragula': '반응 드래그 라',
            'reactDnd': '반응 Dnd',
            'blogManagement': '블로그 관리',
            'ecommerce': '전자 상거래',
            'shopList': '숍리스트',
            'shopGrid': '샵 그리드',
            'invoice': '송장',
            'multilevel': '다중 레벨',
            'sublevel': '하위 레벨',
            'dateTimePicker': '날짜 및 시간 선택기',
            'user': '사용자',
            'miscellaneous': '여러 가지 잡다한',
            'promo': '프로모션',
            'gettingStarted': '시작하기',
            'shop': '가게',
            'cart': '카트',
            'checkout': '점검',
            'saas': 'SAAS',
            'multiLevel': '다중 레벨',
            'level1': '레벨 1',
            'level2': '2 단계',
            'boxed': '박스형',
            'news': '뉴스',
            'extensions': '확장 프로그램',
            'imageCropper': '이미지 자르기 도구',
            'videoPlayer': 'Video Player',
            'dropzone': '비디오 플레이어',
            'crm': 'CRM',
            'projects': '프로젝트들',
            'projectDetail': '프로젝트 세부 사항',
            'clients': '고객',
            'reports': '보고'
        },
        'widgets': {
            'totalEarns': '총 수입',
            'emailsStatistics': '이메일 통계',
            'totalRevenue': '총 수익',
            'onlineVistors': '온라인 방문자',
            'trafficSources': '트래픽 소스',
            'RecentOrders': '최근 주문들',
            'topSellings': '인기 판매',
            'productReports': '제품 보고서',
            'productStats': '제품 통계',
            'ComposeEmail': '이메일을 쓰다',
            'employeePayroll': '직원 급여',
            'visitors': '방문객',
            'orders': '명령',
            'orderStatus': '주문 상태',
            'totalSales': '총 매출',
            'netProfit': '순이익',
            'overallTrafficStatus': '전체 트래픽 상태',
            'tax': '세',
            'expenses': '경비',
            'currentTime': '현재 시간',
            'currentDate': '현재 날짜',
            'todayOrders': '오늘 주문',
            'toDoList': '할일 목록',
            'discoverPeople': '사람들을 발견하십시오',
            'commments': '코멘트',
            'newCustomers': '신규 고객',
            'recentNotifications': '최근 알림',
            'ratings': '평점',
            'appNotifications': '앱 알림',
            'newEmails': '새 이메일',
            'siteVisitors': '사이트 방문자',
            'socialCompanines': '사회 동반자',
            'recentActivities': '최근 활동',
            'recentOrders': '최근 주문들',
            'gallery': '갱도',
            'pricing': '가격',
            'enterpriseEdition': '기업용 에디션',
            'personalEdition': '개인용 버전',
            'teamEdition': '팀 에디션',
            'standard': '표준',
            'advanced': '많은',
            'master': '석사',
            'Mega': '메가',
            'logIn': '로그인',
            'signUp': '가입하기',
            'lockScreen': '잠금 화면',
            'alertsWithLink': '링크 경고',
            'additionalContent': '추가 콘텐츠',
            'alertDismiss': '알림 닫기',
            'uncontrolledDisableAlerts': '제어 할 수없는 해제 경고',
            'contexualAlerts': '문맥 경고',
            'alertsWithIcons': '아이콘으로 경고',
            'Simple App Bars': '간단한 응용 프로그램 모음',
            'appBarsWithButtons': '단추가있는 응용 프로그램 막대',
            'imageAvatars': '이미지 아바타',
            'lettersAvatars': '편지 아바타',
            'iconsAvatars': '아이콘 아바타',
            'flatButtons': '플랫 버튼',
            'raisedButton': '제기 된 버튼',
            'buttonWithIconAndLabel': '아이콘 및 레이블 단추',
            'floatingActionButtons': '플로팅 액션 버튼',
            'iconButton': '아이콘 버튼',
            'socialMediaButton': '소셜 미디어 버튼',
            'reactButton': '반응 버튼',
            'buttonOutline': '버튼 개요',
            'buttonSize': '버튼 크기',
            'buttonState': '버튼 상태',
            'buttonNavigationWithNoLabel': '레이블이없는 단추 탐색',
            'buttonNavigation': '버튼 탐색',
            'iconNavigation': '아이콘 탐색',
            'badgeWithHeadings': '제목이있는 배지',
            'contexualVariations': '문맥 변형',
            'badgeLinks': '배지 링크',
            'materialBadge': '재료 배지',
            'simpleCards': '단순 카드',
            'backgroundVarient': '배경 바리 언트',
            'cardOutline': '카드 개요',
            'overlayCard': '오버레이 카드',
            'cardGroup': '카드 그룹',
            'cardTitle': '카드 제목',
            'speacialTitleTreatment': '비평 제목 치료',
            'chipWithClickEvent': '클릭 이벤트 칩',
            'chipArray': '칩 어레이',
            'dialogs': '대화 상자',
            'listDividers': '목록 분할 자',
            'insetDividers': '삽입 분배기',
            'temporaryDrawers': '임시 서랍',
            'permanentDrawers': '영구 서랍',
            'simpleExpansionPanel': '단순 확장 패널 ',
            'controlledAccordion': '통제 아코디언',
            'secondaryHeadingAndColumns': '보조 제목 및 열',
            'imageOnlyGridLists': '그리드 목록 전용 이미지',
            'advancedGridLists': '고급 그리드 목록',
            'singleLineGridLists': '단일 선 그리드 목록',
            'simpleLists': '단순 목록',
            'folderLists': '폴더 목록',
            'listItemWithImage': '이미지가있는 항목 나열',
            'switchLists': '스위치 목록',
            'insetLists': '삽입 목록',
            'nestedLists': '중첩 목록',
            'checkboxListControl': '확인란 목록 제어',
            'pinedSubHeader': '소나무 하위 헤더',
            'InteractiveLists': '대화식 목록',
            'simpleMenus': '간단한 메뉴',
            'selectedMenu': '선택한 메뉴',
            'maxHeightMenu': '최대 높이 메뉴 ',
            'changeTransition': '전환 전환 ',
            'paper': '종이',
            'anchorPlayGround': '앵커 플레이 그라운드',
            'tooltip': '도구 설명',
            'positionedToolTips': '위치 지정된 스낵바',
            'circularProgressBottomStart': '순환 진행 최저 시작',
            'interactiveIntegration': '대화 형 통합',
            'determinate': '한정된',
            'linearProgressLineBar': '선형 진행률 막대',
            'indeterminate': '불확정',
            'buffer': '완충기',
            'query': '질문',
            'transitionControlDirection': '전환 제어 방향',
            'simpleSnackbar': '간단한 스낵바',
            'positionedSnackbar': '위치 지정된 스낵바',
            'contexualColoredSnackbars': '컨텍 스 컬러 스낵바',
            'simpleCheckbox': '간단한 체크 박스',
            'interminateSelection': '간첩 선택',
            'disabledCheckbox': '사용 안 함 확인란',
            'customColorCheckbox': '사용자 정의 색상 확인란',
            'VerticalStyleCheckbox': '세로 스타일 체크 박스',
            'horizontalStyleCheckbox': '가로 스타일 체크 상자',
            'radioButtons': '라디오 버튼',
            'disabledRadio': '사용 중지 된 라디오',
            'withError': '오류 발생',
            'switches': 'Swiches',
            'dateAndTimePicker': '날짜 및 시간 선택기',
            'defaultPicker': '기본 선택 도구',
            'timePicker': '시간 선택기',
            'weekPicker': '주 선택 도구',
            'defaultDatePicker': '기본 날짜 선택 도구',
            'customPicker': '사용자 지정 선택기',
            'tabs': '탭',
            'fixedTabs': '고정 탭',
            'basicTab': '기본 탭',
            'wrappedLabels': '래핑 된 라벨',
            'centeredLabels': '중앙 레이블',
            'forcedScrolledButtons': '강제 스크롤 된 버튼',
            'iconsTabs': '아이콘 탭',
            'withDisableTabs': '탭 사용 중지',
            'iconWithLabel': '레이블이있는 아이콘',
            'stepper': '스테퍼',
            'horizontalLinear': '수평 선형',
            'horizontalNonLinear': '가로 비선형',
            'horizontalLinerAlternativeLabel': '가로형 라이너 대체 라벨',
            'horizontalNonLinerAlternativeLabel': '가로 비선형 대체 라벨',
            'verticalStepper': '수직 스테퍼',
            'descriptionAlert': '설명 경고',
            'customIconAlert': '사용자 정의 아이콘 경고',
            'withHtmlAlert': 'HTML 경고 있음',
            'promptAlert': '프롬프트 경고',
            'passwordPromptAlert': '비밀번호 프롬프트 알림',
            'customStyleAlert': '사용자 정의 스타일 경고',
            'autoComplete': '자동 완성',
            'reactSelect': '반응 선택',
            'downshiftAutoComplete': '다운 시프트 자동 완성',
            'reactAutoSuggests': '자동 제안 제안',
            'aboutUs': '회사 소개',
            'ourVission': '우리의 비젼',
            'ourMissions': '우리의 사명',
            'ourMotivation': '우리의 동기 부여',
            'defualtReactForm': '불확실한 반응 양식',
            'url': '유아르 자형엘',
            'textArea': '텍스트 영역',
            'file': '파일',
            'formGrid': '양식 격자',
            'inlineForm': '인라인 양식',
            'inputSizing': '입력 크기 조정',
            'inputGridSizing': '입력 격자 크기 조정',
            'hiddenLabels': '숨겨진 라벨',
            'formValidation': '양식 유효성 검사',
            'number': '숫자',
            'date': '날짜',
            'time': '시간',
            'color': '색깔',
            'search': '검색',
            'selectMultiple': '여러 항목 선택',
            'inputWithSuccess': '성공 입력',
            'inputWithDanger': '위험으로 입력',
            'simpleTextField': '간단한 텍스트 필드',
            'componet': '구성 요소',
            'layouts': '레이아웃',
            'inputAdorements': '입력 된 장식품',
            'formattedInputs': '형식화 된 입력 사항',
            'simpleSelect': '단순 선택',
            'nativeSelect': '기본 선택',
            'MutltiSelectList': '목록 선택',
            'lineChart': '꺾은 선형 차트',
            'barChart': '막 대형 차트',
            'stackedBarChart': '스택 막 대형 차트',
            'lineBarAreaChart': '선 막대 영역 차트',
            'areaChart': '영역 차트',
            'stackedAreaChart': '스택 영역 차트',
            'verticalChart': '세로 형 차트',
            'radarChart': '레이더 차트',
            'doughnut': '도넛',
            'polarChart': '폴라 차트',
            'pieChart': '파이 차트',
            'bubbleChart': '버블 차트',
            'horizontalBar': '수평 바',
            'basicTable': '기본 테이블',
            'contextualColoredTable': '컨텍 스 컬러 테이블',
            'dataTable': '데이터 테이블',
            'employeeList': '직원 목록',
            'responsiveTable': '반응 형 테이블',
            'responsiveFlipTable': '반응 형 플립 테이블',
            'reactGridControlledStateMode': '반응 그리드 제어 상태 모드',
            'googleMaps': 'Google지도',
            'productsReports': '제품 보고서',
            'taskList': '작업 목록',
            'basicCalender': '기본 캘린더',
            'culturesCalender': '문화 캘린더',
            'dragAndDropCalender': '드래그 앤 드롭 캘린더',
            'selectableCalender': '선택 가능한 캘린더',
            'customRendering': '사용자 정의 렌더링',
            'customCalender': '맞춤 캘린더',
            'searchMailList': '메일 목록 검색',
            'forgetPassword': '비밀번호 잊어 버림',
            'QuickLinks': '빠른 링크',
            'upgrade': '업그레이드',
            'app': '앱',
            'addNew': '새로 추가',
            'orderDate': '주문 날짜',
            'status': '상태',
            'trackingNumber': '추적 번호',
            'action': '액션',
            'designation': '지정',
            'subject': '제목',
            'send': '보내기',
            'saveAsDrafts': '임시 보관함에 저장',
            'onlineSources': '온라인 소스',
            'lastMonth': '지난 달',
            'widgets': '위젯',
            'listing': '목록',
            'paid': '유료',
            'refunded': '환불 됨',
            'done': '완료',
            'pending': '대기 중',
            'cancelled': '취소됨',
            'approve': '승인',
            'following': '다음',
            'follow': '따르다',
            'graphs & Charts': '그래프 및 차트',
            'open': '열기',
            'bounced': '반송 됨',
            'spam': '스팸',
            'unset': '설정 해제',
            'bandwidthUse': '대역폭 사용',
            'dataUse': '데이터 사용',
            'unsubscribe': '구독 취소',
            'profile': '프로필',
            'messages': '메시지',
            'support': '지원',
            'faq (s)': '주장 (들)',
            'upgradePlains': '업그레이드 평야',
            'logOut': '로그 아웃',
            'mail': '우편',
            'adminTheme': '관리자 테마',
            'wordpressTheme': '자료 Wordpress 테마',
            'addToCart': '장바구니에 추가',
            'plan': '계획',
            'basic': '기본',
            'pro': '찬성',
            'startToBasic': '기본 시작',
            'upgradeToPro': 'Pro로 업그레이드',
            'upgradeToAdvance': '전진로 업그레이드',
            'comparePlans': '비교 계획',
            'free': '무료',
            'frequentlyAskedQuestions': '자주 묻는 질문',
            'searchIdeas': '검색 아이디어',
            'startDate': '시작 날짜',
            'endDate': '종료 날짜',
            'category': '케이트 게이트',
            'apply': '적용',
            'downloadPdfReport': 'Pdf 보고서 다운로드',
            'yesterday': '어제',
            'totalOrders': '총 주문 수',
            'totalVisitors': '총 방문자수',
            'typeYourQuestions': '질문 입력',
            'username': '사용자 이름',
            'password': '비밀번호',
            'signIn': '로그인',
            'enterYourPassword': '비밀번호 입력',
            'alreadyHavingAccountLogin': '이미 계정 로그인 필요',
            'composeMail': '편지 쓰기',
            'issue': '발행물',
            'recentChat': '최근 채팅',
            'previousChat': '이전 채팅',
            'all': '모두',
            'filters': '필터',
            'deleted': '삭제됨',
            'starred': '별표가 있음',
            'frontend': '프론트 엔드',
            'backend': '백엔드',
            'api': 'Api',
            'simpleAppBar': '간단한 응용 프로그램 막대',
            'recents': '최근',
            'cardLink': '카드 링크',
            'anotherLink': '다른 링크',
            'cardSubtitle': '카드 자막',
            'confirmationDialogs': '확인 대화 상자',
            'deletableChip': '삭제 가능 칩',
            'customDeleteIconChip': '사용자 정의 아이콘 칩 삭제',
            'openAlertDialog': '경고 대화 상자 열기',
            'openResponsiveDialog': '반응 형 대화 상자 열기',
            'openSimpleDialog': '간단한 대화 상자 열기',
            'openFormDialog': '양식 열기 대화 상자',
            'follower': '추종자',
            'important': '중요',
            'private': '비공개',
            'openLeft': '왼쪽 열기',
            'openRight': '오른쪽 열기',
            'openTop': '상단 열기',
            'openBottom': '아래쪽 열기',
            'selectTripDestination': '여행 목적지 선택',
            'pinnedSubheaderList': '고정 된 하위 헤더 목록',
            'singleLineItem': '단일 품목',
            'acceptTerms': '약관에 동의',
            'optionA': '옵션 에이',
            'optionB': '옵션 비',
            'optionC': '옵션 기음',
            'optionM': '옵션 엠',
            'optionN': 'Option 엔',
            'optionO': '옵션 영형',
            'customColor': '사용자 정의 색상',
            'centeredTabs': '가운데 맞춤 탭',
            'multipleTabs': '여러 탭',
            'preventScrolledButtons': '스크롤 된 단추 방지',
            'browse': '찾아보기',
            'formValidate': '양식 유효성 검사',
            'code': '코드',
            'company': '회사',
            'price': '가격',
            'change': '변경',
            'high': '높음',
            'low': '낮음',
            'volume': '볼륨',
            'personalDetails': '개인 정보',
            'occupation': '직업',
            'companyName': '회사 이름',
            'phoneNo': '전화 번호',
            'city': '도시',
            'zipCode': '우편 번호',
            'updateProfile': '프로필 업데이트',
            'reject': '거부',
            'exportToExcel': '뛰어나다로 내보내기',
            'addNewUser': '새 사용자 추가',
            'workWeek': '일주일',
            'agenda': '비망록',
            'conference': '회의',
            'multilevel': '다중 레벨',
            'dailySales': '일일 판매',
            'today': '오늘',
            'campaignPerformance': '캠페인 실적',
            'supportRequest': '지원 요청',
            'usersList': '사용자 목록',
            'lastWeek': '지난주',
            'buyMore': '더 사',
            'trafficChannel': '트래픽 채널',
            'stockExchange': '증권 거래소',
            'tweets': '짹짹',
            'ourLocations': '우리의 위치',
            'sales': '매상',
            'to': '에',
            'shipTo': '배송지',
            'description': '기술',
            'unitPrice': '단가',
            'total': '합계',
            'note': '노트',
            'chipWithAvatar': '아바타가있는 칩',
            'chipWithTextAvatar': '텍스트 아바타가있는 칩',
            'chipWithIconAvatar': '아이콘 아바타로 칩',
            'customClickableChip': '맞춤형 클릭 칩',
            'outlineChip': '개요 칩',
            'disableChip': '칩 사용 안 함',
            'alertDialog': '알림 대화 상자',
            'animatedSlideDialogs': '애니메이션 슬라이드 대화 상자',
            'fullScreenDialogs': '전체 화면 대화 상자',
            'formDialogs': '양식 대화 상자',
            'simpleDialogs': '간단한 대화 상자',
            'responsiveFullScreen': '반응 형 전체 화면',
            'primary': '행성',
            'social': '사회적인',
            'user': '사용자',
            'admin': '관리자',
            'permanentdrawer': '영구 서랍',
            'persistentdrawer': '지속 서랍',
            'swiches': '부끄러움',
            'horizontalLinearAlternativeLabel': '수평 선형 대체 상표',
            'horizontalNonLinearAlternativeLabel': '수평 비선형 대체 라벨',
            'notifications': '알림',
            'basicAlert': '기본 경고',
            'successAlert': '성공 알림',
            'warningAlert': '경고 경고',
            'reactAutoSuggest': '자동 제안에 반응하십시오.',
            'components': '구성 요소',
            'inputAdornments': '입력 경신',
            'multiSelectList': '다중 선택 목록',
            'updateYourEmailAddress': '이메일 주소 업데이트',
            'selectADefaultAddress': '기본 주소 선택',
            'activity': '활동',
            'basicCalendar': '기본 달력',
            'culturesCalendar': '문화 달력',
            'dragAndDropCalendar': '드래그 앤 드롭 캘린더',
            'quillEditor': '퀼 에디터',
            'reactDND': 'DND에 대응',
            'dragula': '드래그 라',
            'AcceptorrRejectWithin': '허용 또는 거부',
            'quoteOfTheDay': '오늘의 견적',
            'updated10Minago': '10 시간 전에 업데이트 됨',
            'personalSchedule': '개인 일정',
            'activeUsers': '활성 사용자',
            'totalRequest': '총 요청',
            'new': '新',
            'ShareWithFriends': '친구와 공유하십시오!',
            'helpToShareText': '소셜 미디어에있는 친구 및 추종자와 웹 사이트를 공유하여 세상을 넓힐 수있게 도와주십시오!',
            'thisWeek': '이번 주',
            'howWouldYouRateUs': '우리를 어떻게 평가하니?',
            'booking': '예매',
            'confirmed': '확인 됨',
            'monthly': '월간',
            'weekly': '주간',
            'target': '목표',
            'totalActiveUsers': '총 활성 사용자 수',
            'deadline': '마감 시간',
            'team': '팀',
            'projectManagement': '프로젝트 관리',
            'latestPost': '최신 우편물',
            'projectTaskManagement': '프로젝트 작업 관리',
            'selectProject': '프로젝트 선택',
            'activityBoard': '활동위원회',
            'checklist': '체크리스트',
            'baseConfig': '기본 구성',
            'customControlBar': '사용자 정의 컨트롤 막대',
            'withDownloadButton': '다운로드 버튼 포함',
            'httpLiveStreaming': 'HTTP 실시간 스트리밍',
            'keyboardShortcuts': '키보드 단축키',
            'preview': '시사',
            'croppedImage': '자른 이미지',
            'transactionList': '거래 목록',
            'transferReport': '보고서 전송',
            'expenseCategory': '비용 범주',
            'upcomingEvents': '다가오는 이벤트',
            'OngoingProjects': '진행중인 프로젝트',
            'ProjectStatus': '프로젝트 상태',
            'LiveChatSupport': '라이브 채팅 지원'
        },
        'components': {
            'buyNow': '지금 구입',
            'alreadyHavingAccountSignIn': '이미 계정 로그인 중입니다.',
            'enterYourPassword': '비밀번호 입력',
            'unlock': '잠금 해제',
            'enterPasswords': '비밀번호 입력',
            'resetPassword': '암호를 재설정',
            'pageNotfound': '페이지를 찾을 수 없습니다',
            'goToHomePage': '홈 페이지로 이동',
            'sorryServerGoesWrong': '죄송합니다 서버가 잘못되었습니다.',
            'persistentDrawer': '영구 드로어',
            'back': '뒤로',
            'next': '다음',
            'completeStep': '완료 단계',
            'withHtml': 'HTML과 함께',
            'prompt': '프롬프트',
            'withDescription': '설명 포함',
            'success': '성공',
            'passwordPrompt': '비밀번호 프롬프트',
            'warning': '경고',
            'customIcon': '사용자 지정 아이콘',
            'customStyle': '사용자 정의 스타일',
            'basic': '기본',
            'submit': '제출',
            'compose': '작성',
            'sendMessage': '메시지 보내기',
            'addNewTasks': '새 작업 추가',
            'addToCart': '장바구니에 추가',
            'payNow': '지금 지불',
            'print': '인쇄',
            'cart': '카트',
            'viewCart': '장바구니보기',
            'checkout': '점검',
            'summary': '개요',
            'yesterday': '어제',
            'last7Days': '최근 7 일',
            'last1Month': '지난 1 개월',
            'last6Month': '지난 6 개월',
            'spaceUsed': '사용 된 공간',
            'followers': '수행원',
            'trending': '인기 급상승',
            'paid': '유료',
            'refunded': '환불 됨',
            'done': '끝난',
            'pending': '대기중인',
            'cancelled': '취소 된',
            'approve': '승인하다',
            'week': '주',
            'month': '달',
            'year': '년',
            'today': '오늘',
            'popularity': '인기',
            'email': '이메일',
            'drafts': '체커',
            'sent': '전송 됨',
            'trash': '폐물',
            'all': '모든',
            'do': '해야 할 것',
            'title': '표제',
            'projectName': '프로젝트 이름',
            'companyName': '회사 이름',
            'openAlert': '열린 알리미',
            'slideInAlertDialog': '슬라이드 알림 대화 상자',
            'openFullScreenDialog': '전체 화면 대화 상자 열기',
            'basicChip': '기본 칩',
            'clickableChip': '클릭 가능한 칩',
            'left': '왼쪽',
            'right': '권리',
            'expansionPanel1': '확장 패널 1',
            'expansionPanel2': '확장 패널 2',
            'generalSetting': '일반 설정',
            'advancedSettings': '고급 설정',
            'firstName': '이름',
            'lastName': '성',
            'occupation': '직업',
            'phoneNo': '전화 번호',
            'address': '주소',
            'city': '시티',
            'state': '상태',
            'zipCode': '우편 번호',
            'social Connection': '사회적 연결',
            'emailPrefrences': '이메일 환경 설정',
            'myProfile': '내 프로필',
            'product': '생성물',
            'quantity': '수량',
            'totalPrice': '총 가격',
            'removeProduct': '제품 제거',
            'mobileNumber': '휴대 전화 번호',
            'address2Optional': '주소 2 (선택 사항)',
            'country': '국가',
            'zip': '지퍼',
            'saveContinue': '저장하고 계속하기',
            'placeOrder': '주문하기',
            'payment': '지불',
            'billingAddress': '청구 지 주소',
            'ShippingAddressText': '배송 주소는 청구서 수신 주소와 동일합니다.',
            'CartEmptyText': '귀하의 쇼핑 바구니가 비어 있습니다!',
            'NoItemFound': '항목을 찾을 수 없음',
            'goToShop': '가게에 가다',
            'cardNumber': '카드 번호',
            'expiryDate': '만료일',
            'cvv': 'CVV',
            'nameOnCard': '카드 이름',
            'confirmPayment': '지불 확인'
        },
        'compenets': {
            'choose': '선택',
            'username': '사용자 이름',
            'passwords': '비밀번호',
            'signIn': '로그인',
            'dontHaveAccountSignUp': '계정 가입이 없습니다.',
            'enterUserName': '사용자 이름 입력',
            'enterEmailAddress': '이메일 주소 입력',
            'confirmPasswords': '암호 확인'
        },
        'themeOptions': {
            'sidebarOverlay': '사이드 바 오버레이',
            'sidebarBackgroundImages': '사이드 바 배경 이미지',
            'appSettings': '앱 설정',
            'sidebarImage': '사이드 바 이미지',
            'miniSidebar': '미니 사이드 바',
            'boxLayout': '상자 레이아웃',
            'rtlLayout': 'Rtl 레이아웃',
            'darkMode': '어두운 모드',
            'sidebarLight': '빛',
            'sidebarDark': '어두운',
            'themeColor': '테마 색'
        },
        'button': {
            'cancel': '취소',
            'add': '추가',
            'update': '업데이트',
            'reply': '답장',
            'delete': '삭제',
            'yes': '예',
            'viewAll': '모두보기',
            'like': '처럼',
            'assignNow': '지금 할당',
            'seeInsights': '통계보기',
            'acceptTerms': '약관 동의',
            'reject': '받지 않다',
            'addNew': '새로운 걸 더하다',
            'goToCampaign': '캠페인으로 이동',
            'viewProfile': '프로필보기',
            'sendMessage': '문자 보내',
            'saveNow': '지금 저장해',
            'pen': '펜',
            'search': '수색',
            'downloadPdfReport': 'Pdf 보고서 다운로드',
            'primary': '행성',
            'secondary': '반성',
            'danger': '위험',
            'info': '정보',
            'success': '성공',
            'warning': '경고',
            'link': '링크',
            'smallButton': '작은 단추',
            'largeButton': '큰 버튼',
            'blockLevelButton': '블록 레벨 버튼',
            'primaryButton': '기본 버튼',
            'button': '단추',
            'save': '구하다',
            'openMenu': '메뉴 열기',
            'openWithFadeTransition': '페이드 전환으로 열기',
            'openPopover': '열린 팝 오버',
            'accept': '동의',
            'click': '딸깍 하는 소리',
            'complete': '완전한',
            'back': '뒤로',
            'next': '다음 것',
            'completeStep': '완료 단계',
            'error': '오류',
            'writeNewMessage': '새 메시지 쓰기',
            'saveChanges': '변경 사항을 저장하다',
            'addNewUser': '새 사용자 추가',
            'more': '더',
            'useDefaultImage': '기본 이미지 사용',
            'cropImage': '이미지 자르기'
        },
        'hint': {
            'whatAreYouLookingFor': '무엇을 찾고 계십니까?',
            'searchMailList': '메일 목록 검색'
        },
        'module': {
            'inbox': '받은 편지함',
            'drafts': '체커',
            'sent': '전송 됨',
            'trash': '폐물',
            'spam': '스팸',
            'frontend': '프론트 엔드',
            'backend': '백엔드',
            'api': 'Api',
            'issue': '발행물'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {}
    }
};
